import React from 'react'
import { Button, Checkbox, FormControlLabel, Grid, IconButton, InputAdornment, Paper, TextField, Tooltip } from '@material-ui/core'
import { FileCopy } from '@material-ui/icons'
import { Alert } from '@material-ui/lab'
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { blue } from '@material-ui/core/colors';
import { useDispatch } from 'react-redux';
import useNotificationDialog from '../../../shared/components/useNotificationDialog';
import { DeleteItem } from '../../../redux/actions/item/ItemAction';
import { DELETE_CORRECT_ITEM } from '../../../redux/ActionType/ActionType';
import ItemModel from '../../items/model/item';

const SecondItem = ({selection, handleSelection, Item=new ItemModel(), wipeSelectionItem}) => {
    const [copied, setCopied] = React.useState({element : '', state : false});


    const actionDispatch = useDispatch()

    const {ShowNotificationDialog, handleOpen, open, handleClose} = useNotificationDialog()
 

    React.useEffect(()=>{
        if(copied.state){
            setTimeout(() => {
                setCopied({element:'', state : false})
            }, 2000);
        }
    },[copied])

    const handleCopyUrl =(element)=>{
        setCopied({element : element, state : true})
    }

   
    
    const handleDeleteItem=(id)=>{

        const callBack =()=> {
            actionDispatch({ type : DELETE_CORRECT_ITEM.SUCCESS, removeId : id})
            wipeSelectionItem()
        }

        try {
            actionDispatch(DeleteItem(id, callBack))
        } catch (error) {
            console.log(error)
        }finally{
            handleClose()
        }
    }



    return (
        <Paper style={{padding:10 , border:selection=== 2 && `3px solid ${blue[200]}` }} 
                 elevation={4} onClick={()=> handleSelection(2)}>
            <form>
                <Grid container spacing={2}>
                    <Grid container item xs={12} sm={12} justify="center"> 
                        <Button size="small" color="secondary" variant="contained"> duplicate </Button>                     
                        {copied.state && <Alert severity="info" style={{width :'80%'}}> {copied.element} copié </Alert>}
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <TextField margin='dense' disabled label="Nom du Produit" fullWidth
                            variant="outlined" value={Item.Name}
                            InputLabelProps={{ shrink: true}} 
                            InputProps={{ 
                                endAdornment : <InputAdornment position="end" > 
                                <Tooltip title="copy" placement="left-start">
                                 <CopyToClipboard text={Item.Name} onCopy={()=> handleCopyUrl('nom du produit')}>
                                    <IconButton size="small" > 
                                        <FileCopy fontSize="small"  /> 
                                    </IconButton>
                                </CopyToClipboard> 
                                </Tooltip>
                                 
                                </InputAdornment>
                            }}  />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField margin='dense' label="Code barre" fullWidth
                            variant="outlined" disabled 
                            name ="Barcode" value={Item.Barcode}
                            InputLabelProps={{ shrink: true}} 
                            InputProps={{ 
                                endAdornment : <InputAdornment position="end" >  
                                 <Tooltip title="copy" placement="left-start">
                                <CopyToClipboard text={Item.Barcode} onCopy={()=> handleCopyUrl('code barre')}>
                                     <IconButton size="small"> 
                                        <FileCopy fontSize="small"  /> 
                                    </IconButton> 
                                </CopyToClipboard>
                                 </Tooltip>
                                </InputAdornment>
                            }}   />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField margin='dense' label="Prosoft Id" fullWidth
                            variant="outlined" disabled value={Item.InternalId}
                            InputLabelProps={{ shrink: true}} 
                            InputProps={{ 
                                endAdornment : <InputAdornment position="end" >  
                                 <Tooltip title="copy" placement="left-start">
                                    <CopyToClipboard text={Item.InternalId} onCopy={()=>  handleCopyUrl('Prosoft id')}>
                                        <IconButton size="small" > 
                                            <FileCopy fontSize="small"  /> 
                                        </IconButton> 
                                    </CopyToClipboard>                 
                                 </Tooltip>
                                </InputAdornment>
                            }}  />
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <TextField margin='dense' disabled label="Lien de l'image" fullWidth
                            variant="outlined"
                            InputLabelProps={{ shrink: true}}  value={Item.ImageUrl}
                            InputProps={{ 
                                endAdornment : <InputAdornment position="end" >
                                     <Tooltip title="copy" placement="left-start">
                                        <CopyToClipboard text={Item.ImageUrl} onCopy={()=> handleCopyUrl('lien image')}>
                                            <IconButton size="small"> 
                                                <FileCopy fontSize="small"  />
                                            </IconButton>  
                                        </CopyToClipboard>    
                                    </Tooltip>  
                                </InputAdornment>
                            }}  />
                    </Grid>
                    <Grid item xs={12} sm={4} style={{marginTop:5}}>
                         <FormControlLabel label="Pack"  control={<Checkbox disabled checked={Item.HasChilds} color="primary" />} />
                    </Grid>

                    <Grid container spacing={3} justify="flex-end">
                      {open &&  <ShowNotificationDialog title="Suppression"
                            action={ 
                            <React.Fragment>
                                <Grid container justify="space-between" >
                                    <Grid item xs={3} sm={3}> <Button color="primary" onClick={handleClose}> Annuler </Button> </Grid>
                                    <Grid item xs={3} sm={3}> <Button color="secondary" onClick={()=>handleDeleteItem(Item.id)}> Supprimer </Button> </Grid>
                                </Grid>
                            </React.Fragment> }>
                            <Alert severity="warning"> vous êtes certains ce vouloir supprimer ce produit ? </Alert>
                        </ShowNotificationDialog>}
                        <Grid item>
                            <Button  disabled={Item.id ? false : true} variant="contained" color="secondary" onClick={handleOpen}> delete </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </Paper>
    )
}

export default SecondItem
